"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DoubleUp_exports = {};
__export(DoubleUp_exports, {
  default: () => DoubleUp_default
});
module.exports = __toCommonJS(DoubleUp_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M4.91406 8.82422L9.91406 3.82422C10.0703 3.66797 10.2656 3.58984 10.5 3.58984C10.7344 3.58984 10.9297 3.66797 11.0859 3.82422L16.0859 8.82422C16.2552 8.99349 16.3398 9.19531 16.3398 9.42969C16.3398 9.65104 16.2552 9.84635 16.0859 10.0156C15.9297 10.1719 15.7344 10.25 15.5 10.25C15.2656 10.25 15.0703 10.1719 14.9141 10.0156L10.5 5.60156L6.08594 10.0156C5.92969 10.1719 5.73438 10.25 5.5 10.25C5.26562 10.25 5.07031 10.1719 4.91406 10.0156C4.74479 9.84635 4.66016 9.65104 4.66016 9.42969C4.66016 9.19531 4.74479 8.99349 4.91406 8.82422ZM4.91406 15.4844L9.91406 10.4844C10.0703 10.3281 10.2656 10.25 10.5 10.25C10.7344 10.25 10.9297 10.3281 11.0859 10.4844L16.0859 15.4844C16.2552 15.6536 16.3398 15.8555 16.3398 16.0898C16.3398 16.3112 16.2552 16.5065 16.0859 16.6758C15.9297 16.832 15.7344 16.9102 15.5 16.9102C15.2656 16.9102 15.0703 16.832 14.9141 16.6758L10.5 12.2617L6.08594 16.6758C5.92969 16.832 5.73438 16.9102 5.5 16.9102C5.26562 16.9102 5.07031 16.832 4.91406 16.6758C4.74479 16.5065 4.66016 16.3112 4.66016 16.0898C4.66016 15.8555 4.74479 15.6536 4.91406 15.4844Z",
      fill: "currentColor"
    }
  )
);
const SvgDoubleUp = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DoubleUp_default = SvgDoubleUp;
